export default __webpack_public_path__ + "static/media/INDXXF.bada15ad.png";